import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { toggleKeyboardListeners } from '$redux/ui/uiActions';

export function useKeyboardShortcutsListenerToggle() {
    const dispatch = useDispatch();

    const isKeyboardInputElement = (element: Element) => {
        const tagName = element.tagName;
        switch (tagName) {
            case 'INPUT': {
                const inputType = element.getAttribute('type');
                if (inputType === 'checkbox' || inputType === 'radio') {
                    return false;
                }
                break;
            }
            case 'TEXTAREA':
                break;
            case 'DIV':
                return element.role === 'textbox';
            default:
                return false;
        }
        return true;
    };

    const toggleKeyboardListenerOnFocus = (e) => {
        if (isKeyboardInputElement(e.target)) {
            dispatch(toggleKeyboardListeners(false));
        }
    };
    const toggleKeyboardListenerOnBlur = (e) => {
        if (isKeyboardInputElement(e.target)) {
            dispatch(toggleKeyboardListeners(true));
        }
    };

    useEffect(() => {
        document.addEventListener('focusin', toggleKeyboardListenerOnFocus);
        document.addEventListener('focusout', toggleKeyboardListenerOnBlur);

        return () => {
            document.removeEventListener('focusin', toggleKeyboardListenerOnFocus);
            document.removeEventListener('focusout', toggleKeyboardListenerOnBlur);
        };
    }, []);
}
